import { Component, OnInit } from '@angular/core'
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'
import { customEmailValidator, validateAllFormFields } from 'models/form'
import { finalize, first } from 'rxjs'
import { BaseModule } from 'shared/base/base.module'
import { UserService } from '../../services/hubtype-api/user.service'

@Component({
  selector: 'app-reset-pwd',
  templateUrl: 'reset_pwd.component.html',
  imports: [ReactiveFormsModule, RouterModule, BaseModule, TranslatePipe],
})
export class ResetPwdComponent implements OnInit {
  error: string
  form = this.fb.group({
    email: ['', [Validators.required, customEmailValidator()]],
  })
  initialEmail: string
  sended = false
  resended = false

  isLoading = false

  constructor(
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.setInitialEmail()
  }

  onSubmit() {
    validateAllFormFields(this.form)

    if (this.form.invalid) {
      return false
    }

    this.isLoading = true
    this.userService
      .forgotPassword(this.form.value.email)
      .pipe(
        finalize(() => {
          this.isLoading = false
        })
      )
      .subscribe(() => {
        this.sended = true
      })
  }

  resendEmail() {
    this.onSubmit()
    this.resended = true
  }

  private setInitialEmail() {
    this.route.queryParams.pipe(first()).subscribe(params => {
      this.form.patchValue({
        email: params['email'],
      })
    })
  }
}
